import { z } from 'zod';
import { CATEGORIES } from './constants';

export const CategorySchema = z.enum(CATEGORIES);

export const MilestoneSpecSchema = z.object({
  title: z.string().min(1).max(200),
  amount: z.number().positive().finite(),
});

export const CreateJobSchema = z.object({
  title: z.string().min(1).max(200),
  description: z.string().min(1).max(5000),
  category: CategorySchema,
  milestones: z.array(MilestoneSpecSchema).min(1),
  autoRelease: z.boolean().default(true),
  depositTx: z.string().min(1).max(128).optional(),
});

export const CreateProposalSchema = z.object({
  price: z.number().positive().finite(),
  days: z.number().int().min(1).max(365),
  message: z.string().max(2000),
});

export const UpdateProfileSchema = z
  .object({
    skill: z.string().max(200).optional(),
    bio: z.string().max(500).optional(),
    rate: z.number().min(0).finite().optional(),
    channel: z
      .object({
        handle: z.string().min(1).max(64),
        subscriberCount: z.number().int().min(0).optional(),
        lastPostAt: z.number().int().nonnegative().optional(),
      })
      .nullable()
      .optional(),
  })
  .refine(
    (value) =>
      value.skill !== undefined ||
      value.bio !== undefined ||
      value.rate !== undefined ||
      value.channel !== undefined,
    { message: 'empty patch' },
  );

export const DeliverSchema = z.object({
  note: z.string().max(2000).optional(),
});

export const DisputeSchema = z.object({
  reason: z.string().min(1).max(2000),
});

export const RateSchema = z.object({
  rating: z.number().int().min(1).max(5),
});

/** Pointer only. Extra money fields are rejected, not stored. */
export const AttachContractSchema = z
  .object({
    address: z.string().min(1).max(128),
    locator: z.string().min(1).max(128),
  })
  .strict();
